import {appPaymentId, paypalPaymentId} from '@app/settings';
import helpers from '@app/helpers';

export const getters = {

	userLocation: (state) => helpers.methods.getProp(state, 'user.location', null),

	userToken: (state) => helpers.methods.getProp(state, 'user.account.X-Auth-UserToken', ''),

	isUserLoggedIn: (state) => {
		return !!helpers.methods.getProp(state, 'user.account.X-Auth-UserToken', null);
	},

	loginError: (state) => helpers.methods.getProp(state, 'user.loginError', null),

	registerError: (state) => helpers.methods.getProp(state, 'user.registerError', null),

	siteId: (state) => helpers.methods.getProp(state, 'venue.id', null),

	getSalesAreas: (state) => helpers.methods.getProp(state, 'venue.salesArea', null),

	salesAreaId: (state) => {
		const salesAreas = helpers.methods.getProp(state, 'venue.salesArea', null);
		const mobileOrderingArea = salesAreas.find(area => /mobile|mo downstairs/i.test(area.name));
		return mobileOrderingArea.id;
	},

	venue: (state) => helpers.methods.getProp(state, 'venue', null),

	getMenu: (state) => helpers.methods.getProp(state, 'menuList', null),

	orderedMenus: (state) => {
		let m = helpers.methods.getProp(state, 'menuList.menus', []);
		return m.sort((a, b) => a.sortOrder - b.sortOrder);
	},

	getCourses: (state) => helpers.methods.getProp(state, 'menuList.courses', null),

	orderedCourses: (state) => {
		let c = helpers.methods.getProp(state, 'menuList.courses', []);
		return c.sort((a, b) => a.sortOrder - b.sortOrder);

	},

	timeslots: (state) => {
		let n = helpers.methods.getProp(state, 'timeslots', []);
		return n.filter(val => val.available);
	},

	basketId: (state) => helpers.methods.getProp(state, 'basket.status.basketId', null),

	isBasketEmpty: (state) => {
		let l = helpers.methods.getProp(state, 'basket.lines', []);
		return l.length < 1;
	},

	basket: (state) => state.basket,

	basketNumberOfItems: (state) => {
		return state.basket.lines.length;
	},

	basketTotal: (state) => {

		let total = 0;

		state.basket.lines.forEach((item) => {
			var lineItemTotalPrice = helpers.methods.updateLineItemPrice(item).totalPrice;
			total += lineItemTotalPrice;
		});

		return helpers.methods.toPoundStr(total);
	},

	basketArray: (state) => {

		let lines = [];
		state.basket.lines.forEach(lineItem => {

			/* Parse choices into correct format for API */
			let choiceLines = [];
			Object.keys(lineItem.choices).map((groupId, choiceIndex) => {

				const group = lineItem.choices[groupId];

				Object.keys(group).map((choiceId) => {

					const choice = group[choiceId];

					let choicePayload = {
						ingredientId: choice.productId,
						portionTypeId: '1',
						displayRecordId: choice.displayRecords[0].productDisplayRecordId,
						quantity: choice.portion.quantity,
						choiceIndex: choice.choiceGroupIndex,
						choiceId: groupId
					};

					for (let i = 0, len = choice.portion.quantity; i < len; i++) {
						choiceLines.push(choicePayload);
					}

				});
			});

			/* Push basket lines */
			lines.push({
				ingredientId: lineItem.item.product.id,
				portionTypeId: lineItem.portion.id,
				displayRecordId: lineItem.displayRecordId,
				courseId: lineItem.item.product.defaultCourseId,
				quantity: lineItem.quantity,
				choiceLines: choiceLines
			});

		});
		return lines;
	},

	selectedTimeslot: (state) => helpers.methods.getProp(state, 'basket.timeslot', null),

	userEmail: (state) => helpers.methods.getProp(state, 'user.account.user.email', null),

	deviceData: (state) => helpers.methods.getProp(state, 'user.currentPaymentMethod.deviceData', null),

	nonce: (state) => helpers.methods.getProp(state, 'user.currentPaymentMethod.nonce', null),

	paymentMethodId: (state) => {
		let paymentType = helpers.methods.getProp(state, 'user.currentPaymentMethod.type', null);
		return (paymentType === 'paypal') ? paypalPaymentId : appPaymentId;
	},

	getCurrentPaymentMethod: (state) => helpers.methods.getProp(state, 'user.currentPaymentMethod', {}),

	getLocations: (state) => {
		return state.locations;
	},

	getLocationsLoaded: (state) => {
		return state.locationsLoaded;
	},

	getUiCopy: (state) => {
		return state.uiCopy;
	}

};



// WEBPACK FOOTER //
// ./src/vue/store/getters.js